import { call, take, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { pingLogout } from '../utils/lrs';

/* Local-password endpoint */
const LOCAL_LOGOUT =
  'https://www.yisumatica.org.il/users/publicaccess/logout/';

/* SAML Single-Logout for MoE. Replace if your URL differs. */
const MOE_SLO =
  'https://lgn.edu.gov.il/nidp/saml2/slo?sid=logout&target=https://www.yisumatica.org.il';

const selectSession = (s: any) => s.session;

function clearCookies() {
  document.cookie.split(';').forEach((c) => {
    const name = c.split('=')[0].trim();
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  });
}

function* signOut(): Generator {
  while (true) {
    yield take('LOG_OUT_SAGA');

    const session = (yield select(selectSession)) as any;
    const isMoE = Boolean(session?.semelMosad);
    const userId = session?.id || localStorage.getItem('userId') || 'unknown';
    const sessionDuration = localStorage.getItem('sessionDuration');

    console.group('[LOGOUT] Logout saga triggered');
    console.log('[LOGOUT] User info:', { userId, isMoE, semelMosad: session?.semelMosad });
    console.log('[LOGOUT] Session duration in localStorage:', sessionDuration, 'seconds');

    /* 1️⃣  LRS exit (MoE): send full MoE-compliant statement */
    console.log('[LOGOUT] Calling pingLogout with:', { userId, semelMosad: session?.semelMosad || '' });
    yield call(pingLogout as any, userId, session?.semelMosad || '');
    console.log('[LOGOUT] pingLogout completed');
    
    const payload = { userId, timestamp: new Date().toISOString() };
    yield put({ type: 'RECORD_USER_LOGOUT', payload });
    console.log('[LOGOUT] RECORD_USER_LOGOUT action dispatched');

    /* 2️⃣  Branch */
    if (isMoE) {
      console.log('[LOGOUT] MoE logout - clearing cookies and redirecting to SLO');
      clearCookies();
      window.location.assign(MOE_SLO);
    } else {
      console.log('[LOGOUT] Local logout - calling local endpoint');
      try {
        yield call(axios.post, LOCAL_LOGOUT);
        console.log('[LOGOUT] Local logout endpoint called successfully');
      } catch (e) {
        console.warn('[LOGOUT] local endpoint error (ignored):', e);
      }
      clearCookies();
      console.log('[LOGOUT] Cookies cleared, redirecting to home');
      window.location.assign('https://www.yisumatica.org.il');
    }
    console.groupEnd();
  }
}

export default signOut;
